// PerfNum — performance number cell. Colors by sign (gain/loss) and prefixes
// the sign. Used for return/gain columns in Portfolio and Manage tables.
import PropTypes from 'prop-types';
import { cx } from '../../../utils/cx';
import { formatPercent } from '../../../utils/format';
import { ChevronUpIcon, ChevronDownIcon } from '../../icons/Icons';
import './perf-num.css';

export function PerfNum({ value, percent = true, digits = 2, arrow = false, className }) {
  const tone = value > 0 ? 'gain' : value < 0 ? 'loss' : 'flat';
  const text = percent ? formatPercent(value, { digits, signed: true }) : value;
  return (
    <span className={cx('perf-num', `perf-num--${tone}`, arrow && 'perf-num--arrow', className)}>
      {arrow && value > 0 && <ChevronUpIcon className="perf-num__arrow" />}
      {arrow && value < 0 && <ChevronDownIcon className="perf-num__arrow" />}
      {text}
    </span>
  );
}

PerfNum.propTypes = {
  value: PropTypes.number,
  percent: PropTypes.bool,
  digits: PropTypes.number,
  /** Prefix a directional chevron (up for gains, down for losses). */
  arrow: PropTypes.bool,
  className: PropTypes.string,
};

export default PerfNum;
